/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scim_Setup_Okta_Step1Inputs */



/**
* | output |
* | --- |
* | "Go to Applications > Create App Integration" |
*
* @param {Scim_Setup_Okta_Step1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const scim_setup_okta_step1 = /** @type {((inputs?: Scim_Setup_Okta_Step1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scim_Setup_Okta_Step1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Gehen Sie zu Anwendungen > App-Integration erstellen")
	return /** @type {LocalizedString} */ ("Go to Applications > Create App Integration")
});